import { Provider } from '@angular/core';
import { MAT_RIPPLE_GLOBAL_OPTIONS } from '@angular/material/core';
import { provideAnimations } from '@angular/platform-browser/animations';

import { FU_CONFIG, FU_TOAST_CONFIG, FU_TOAST_DEFAULT_CONFIG, matGlobalRippleConfig } from '@hglobal/fin-ui';

import { environment } from '@drf/environments';

export function provideFinUi(): Provider[] {
  return [
    provideAnimations(),
    {
      provide: MAT_RIPPLE_GLOBAL_OPTIONS,
      useValue: matGlobalRippleConfig,
    },
    {
      provide: FU_CONFIG,
      useValue: {
        apiHost: environment.apiHost,
        useMocks: environment.useMocks,
        production: environment.production,
      },
    },
    {
      provide: FU_TOAST_CONFIG,
      useValue: FU_TOAST_DEFAULT_CONFIG,
    },
  ];
}
